import { render, staticRenderFns } from "./detailsHistory.vue?vue&type=template&id=625d30ac&"
import script from "./detailsHistory.vue?vue&type=script&lang=js&"
export * from "./detailsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports